import { ArrowLeft, ChevronRight } from "lucide-react";
import { Category, Subcategory } from "@/hooks/useKnowledgeBase";

interface KnowledgeCategoryViewProps {
  category: Category;
  subcategory?: Subcategory;
  onSelectArticle: (articleId: string) => void;
  onSelectSubcategory?: (subcategoryId: string) => void;
  onBack: () => void;
}

export function KnowledgeCategoryView({ category, subcategory, onSelectArticle, onSelectSubcategory, onBack }: KnowledgeCategoryViewProps) {
  const showSubcategories = !subcategory && category.subcategories && category.subcategories.length > 0;
  const articles = subcategory ? subcategory.articles : category.articles;

  return (
    <div className="space-y-6 pt-2">
      <div className="space-y-3">
        <button
          className="flex items-center gap-1 text-sm px-3 py-1.5 rounded-lg bg-[hsl(0,0%,85%)] hover:bg-[hsl(0,0%,78%)] text-black transition-colors"
          onClick={onBack}
        >
          <ArrowLeft className="w-4 h-4" />
          Volver
        </button>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-psi-lime/10 flex items-center justify-center">
            {subcategory ? (
              <subcategory.icon className="w-5 h-5 text-psi-lime" />
            ) : (
              <category.icon className="w-5 h-5 text-psi-lime" />
            )}
          </div>
          <div>
            <h2 className="text-xl sm:text-2xl font-bold text-white">
              {subcategory ? subcategory.title : category.title}
            </h2>
            <p className="text-white/60 text-sm">
              {subcategory ? subcategory.description : category.description}
            </p>
          </div>
        </div>
      </div>

      {showSubcategories && (
        <div className="space-y-3">
          {category.subcategories!.map((sub) => (
            <div
              key={sub.id}
              className="cursor-pointer rounded-xl border border-white/15 bg-white/8 hover:bg-psi-lime/30 transition-colors"
              onClick={() => onSelectSubcategory?.(sub.id)}
            >
              <div className="p-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center">
                    <sub.icon className="w-4 h-4 text-white/60" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-white">{sub.title}</p>
                    <p className="text-xs text-white/50">
                      {sub.description} · {sub.articles.length} recurso{sub.articles.length !== 1 ? "s" : ""}
                    </p>
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-white/40 flex-shrink-0" />
              </div>
            </div>
          ))}
        </div>
      )}

      {articles.length > 0 && (
        <div className="space-y-3">
          {articles.map((article) => (
            <div
              key={article.id}
              className="cursor-pointer rounded-xl border border-white/15 bg-white/8 hover:bg-psi-lime/30 transition-colors"
              onClick={() => onSelectArticle(article.id)}
            >
              <div className="p-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center">
                    <article.icon className="w-4 h-4 text-white/60" />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-white">{article.title}</p>
                    <p className="text-xs text-white/50">{article.description}</p>
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-white/40 flex-shrink-0" />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
